export default {
    DEEZER: {
        title: 'Deezer',
        value: 0
    },
    FACEBOOK: {
        title: 'Facebook',
        value: 1
    },
    TWITTER: {
        title: 'Twitter',
        value: 2
    },
    toArray()
    {
        return [
            this.DEEZER,
            this.FACEBOOK,
            this.TWITTER
        ]
    }
}
